"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _admin = require("@/store/modules/admin");
let App = class App extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.idleTimeout = null;
    this.countdownTimer = null;
    this.countdownSeconds = 15;
    this.isCountingDown = false;
    // ==============================
    // USER ACTIVITY HANDLING
    // ==============================
    this.handleActivity = () => {
      if (!_admin.AdminModule.token) return;
      if (this.isCountingDown) {
        this.stopCountdown();
      }
      this.resetIdleTimer();
    };
  }
  // ==============================
  // LIFECYCLE
  // ==============================
  mounted() {
    this.attachActivityListeners();
    // Start tracking only if logged in
    if (_admin.AdminModule.token) {
      this.startSessionTracking();
    }
  }
  beforeDestroy() {
    this.removeActivityListeners();
    this.clearAllTimers();
  }
  get token() {
    return _admin.AdminModule.token;
  }
  // ==============================
  // WATCH TOKEN (IMPORTANT)
  // ==============================
  onTokenChange(newToken) {
    if (newToken) {
      this.startSessionTracking();
    } else {
      this.clearAllTimers();
    }
  }
  // ==============================
  // SESSION MANAGEMENT
  // ==============================
  startSessionTracking() {
    this.resetIdleTimer();
  }
  resetIdleTimer() {
    if (!_admin.AdminModule.token) return;
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
    this.idleTimeout = setTimeout(() => {
      this.startCountdown();
    }, 10 * 60 * 1000); // 10 minutes
  }
  startCountdown() {
    if (!_admin.AdminModule.token) return;
    this.isCountingDown = true;
    this.countdownSeconds = 15;
    this.countdownTimer = setInterval(() => {
      this.countdownSeconds--;
      if (this.countdownSeconds <= 0) {
        this.clearAllTimers();
        this.$alert('Your session is over. Please login again.', 'Session Expired', {
          confirmButtonText: 'OK',
          type: 'warning'
        }).then(() => {
          _admin.AdminModule.LogOut();
        });
      }
    }, 1000);
  }
  stopCountdown() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    this.isCountingDown = false;
  }
  clearAllTimers() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
      this.idleTimeout = null;
    }
    this.stopCountdown();
  }
  attachActivityListeners() {
    window.addEventListener('mousemove', this.handleActivity);
    window.addEventListener('keydown', this.handleActivity);
    window.addEventListener('click', this.handleActivity);
    window.addEventListener('scroll', this.handleActivity);
  }
  removeActivityListeners() {
    window.removeEventListener('mousemove', this.handleActivity);
    window.removeEventListener('keydown', this.handleActivity);
    window.removeEventListener('click', this.handleActivity);
    window.removeEventListener('scroll', this.handleActivity);
  }
  // ==============================
  // STAY LOGGED IN
  // ==============================
  stayLoggedIn() {
    this.stopCountdown();
    this.resetIdleTimer();
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('token')], App.prototype, "onTokenChange", null);
App = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], App);
var _default = exports.default = App;